import { render, staticRenderFns } from "./CreateRoute.vue?vue&type=template&id=aab6a0d8&scoped=true&"
import script from "./CreateRoute.vue?vue&type=script&lang=js&"
export * from "./CreateRoute.vue?vue&type=script&lang=js&"
import style0 from "./CreateRoute.vue?vue&type=style&index=0&id=aab6a0d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab6a0d8",
  null
  
)

component.options.__file = "CreateRoute.vue"
export default component.exports